export default {
  apartments: {
    breadcrumbHome: 'Inicio',
    breadcrumbSolutions: 'Soluciones',
    breadcrumbCurrent: 'Edificios de viviendas e inmuebles',
    hero: {
      eyebrow: 'Edificios de viviendas e inmuebles',
      title: 'Seguridad para edificios residenciales completos',
      lead: 'Entrada, escalera, garaje subterráneo: planificamos vigilancia para edificios que protege a los inquilinos y da tranquilidad a los propietarios.',
    },
    areas: {
      title: 'Puntos de vigilancia en edificios de viviendas',
      lead: 'Las zonas comunes son los puntos de partida más importantes. Siempre respetamos los derechos de todos los residentes.',
      items: {
        '0': { title: 'Entrada del edificio', desc: 'La entrada es la tarjeta de presentación del edificio y el punto de vigilancia más importante. Las cámaras captan quién entra.' },
        '1': { title: 'Escalera', desc: 'Las escaleras son transiciones con mucho movimiento. Cámaras compactas cierran los huecos entre plantas con discreción.' },
        '2': { title: 'Trastero de bicis', desc: 'Bicis y e-bikes son objetivos habituales de robo. La vigilancia disuade y ayuda a aclarar.' },
        '3': { title: 'Zonas exteriores', desc: 'Parques, zonas verdes y caminos son comunitarios. Cámaras resistentes protegen también aquí.' },
        '4': { title: 'Garaje subterráneo', desc: 'Las plazas del garaje subterráneo son vulnerables de noche. La vigilancia bien iluminada aporta seguridad.' },
        '5': { title: 'Buzones', desc: 'Buzones y taquillas de paquetería son clave para el robo de paquetes. Las cámaras de acceso ayudan mucho.' },
      },
    },
    protection: {
      eyebrow: 'Protección de datos y normas',
      title: 'Vigilar sin vulnerar',
      lead: 'En un edificio confluyen muchos intereses. Implementamos la vigilancia respetando la privacidad de los residentes y de forma legal.',
      items: {
        '0': { title: 'Enmascaramiento de privacidad', desc: 'Ventanas, puertas y zonas privadas se ocultan técnicamente; solo quedan las zonas comunes.' },
        '1': { title: 'Acuerdo y normas', desc: 'La videovigilancia en edificios necesita una base sólida. Le apoyamos en la implementación.' },
        '2': { title: 'Señalización', desc: 'Avisos claros en la entrada informan a inquilinos y visitantes, de forma transparente y justa.' },
      },
    },
    value: {
      eyebrow: 'Valor añadido',
      title: 'Ventajas para propietarios y administradores',
      lead: 'Un sistema bien pensado beneficia a todos: los inquilinos se sienten más seguros, los propietarios protegen su activo y los administradores ganan claridad.',
      list: {
        '0': 'Acceso para administradores y propietarios con derechos separados',
        '1': 'Grabación de los últimos días o semanas, según configuración',
        '2': 'Alivio para la administración en incidentes y disputas',
        '3': 'Documentación completa ante vandalismo o robo',
        '4': 'Disuasión de accesos no autorizados',
        '5': 'Mayor sensación de seguridad para inquilinos y propietarios',
      },
      note: 'Nota: la legalidad de la videovigilancia en edificios depende mucho del caso. Le asesoramos, sin sustituir el asesoramiento jurídico.',
    },
    cta: {
      title: 'Más seguridad para su edificio',
      lead: 'Asesoramos a comunidades de propietarios y administradores sin compromiso, de la idea al sistema llave en mano.',
      primary: 'Concertar una cita de asesoría',
      secondary: 'Iniciar el planificador de cámaras',
    },
  },
};